import ListEquipmentPage from "./ListEquipmentPage";

export default ListEquipmentPage;
